import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { useWishlist } from "@/context/WishlistContext";
import { Heart, X } from "lucide-react";

export default function Wishlist() {
  const { user } = useAuth();
  const { items, remove, refresh } = useWishlist();

  useEffect(() => { refresh(); }, [refresh]);

  if (!user) {
    return (
      <div className="container-editorial mt-14 py-20 text-center">
        <p className="label-uppercase text-[#B24C38]">Wishlist</p>
        <h1 className="font-serif text-5xl tracking-tighter mt-3">Sign in to save pieces.</h1>
        <p className="text-[#4A4A4A] mt-4">Save your favourite pieces and get notified when your size is back.</p>
        <Link to="/login?redirect=/wishlist" className="btn-terracotta mt-8 inline-flex">Sign In →</Link>
      </div>
    );
  }

  return (
    <div className="container-editorial mt-8 md:mt-14">
      <div className="border-b border-[#EAE5D9] pb-10 mb-12">
        <p className="label-uppercase text-[#B24C38]">Your saved pieces</p>
        <h1 className="font-serif text-5xl md:text-6xl lg:text-7xl tracking-tighter mt-3">Wishlist</h1>
        <p className="text-[#4A4A4A] mt-4 max-w-xl">
          We'll email you the moment a saved size is restocked at the atelier.
        </p>
      </div>

      {items.length === 0 ? (
        <div className="py-24 text-center">
          <Heart className="w-10 h-10 mx-auto text-[#4A4A4A]" strokeWidth={1.5}/>
          <p className="font-serif text-3xl mt-6 mb-6">Nothing saved yet.</p>
          <Link to="/shop" className="btn-terracotta">Browse the shop →</Link>
        </div>
      ) : (
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-x-4 gap-y-14">
          {items.map(it => {
            const p = it.product; if (!p) return null;
            return (
              <div key={it.id} className="group relative" data-testid={`wishlist-item-${it.product_id}`}>
                <Link to={`/product/${p.id}`}>
                  <div className="product-image-wrap">
                    <img src={p.images?.[0]} alt={p.name}/>
                  </div>
                </Link>
                <button onClick={() => remove(p.id, it.size)}
                        data-testid={`wishlist-remove-${it.product_id}`}
                        className="absolute top-3 right-3 w-9 h-9 flex items-center justify-center bg-[#F7F5F0]/95">
                  <X className="w-4 h-4"/>
                </button>
                <div className="mt-4 flex justify-between items-start">
                  <div>
                    <p className="text-xs text-[#4A4A4A] label-uppercase">{p.category}</p>
                    <p className="font-serif text-lg md:text-xl mt-1">{p.name}</p>
                    {it.size && <p className="text-xs text-[#4A4A4A] mt-1">Size {it.size}</p>}
                    {it.notify_restock && (
                      <p className="text-xs text-[#2C402E] mt-2 label-uppercase">Restock alerts on</p>
                    )}
                  </div>
                  <p className="font-serif text-lg md:text-xl">${p.price.toFixed(0)}</p>
                </div>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
}
